/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PythonEnvironment
 */
export interface PythonEnvironment {
    /**
     * 
     * @type {string}
     * @memberof PythonEnvironment
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PythonEnvironment
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PythonEnvironment
     */
    version: string;
}

export function PythonEnvironmentFromJSON(json: any): PythonEnvironment {
    return PythonEnvironmentFromJSONTyped(json, false);
}

export function PythonEnvironmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): PythonEnvironment {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'version': json['version'],
    };
}

export function PythonEnvironmentToJSON(value?: PythonEnvironment | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'version': value.version,
    };
}


